import React from 'react';
import theme from '@theme';

interface TableIconProps {
  fill?: string;
}

const TableIcon = ({ fill = theme.palette.common.white }: TableIconProps) => (
  <svg width="20" height="20" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.902 4.77625L12.7082 2.76753C12.62 2.70189 12.5128 2.6665 12.4025 2.6665H4.59229C4.48203 2.6665 4.37485 2.70189 4.28613 2.76753L2.03998 4.81881C2.03998 4.81881 1.83331 4.95009 1.83331 5.23061V6.25625C1.83331 6.53881 2.06357 6.76907 2.34613 6.76907H14.6538C14.9364 6.76907 15.1666 6.53881 15.1666 6.25625V5.23061C15.1666 4.9583 14.902 4.77625 14.902 4.77625Z"
      fill={fill}
    />
    <path
      d="M2.85901 12.923C2.57645 12.923 2.34619 12.6928 2.34619 12.4102V6.25635H3.88465V12.4102C3.88465 12.6928 3.6544 12.923 3.37183 12.923H2.85901Z"
      fill={fill}
    />
    <path
      d="M13.6282 12.923C13.3456 12.923 13.1154 12.6928 13.1154 12.4102V6.25635H14.6538V12.4102C14.6538 12.6928 14.4236 12.923 14.141 12.923H13.6282Z"
      fill={fill}
    />
    <path
      d="M12.0897 10.3587C11.8072 10.3587 11.5769 10.1284 11.5769 9.84584V7.28174H12.6025V9.84584C12.6025 10.1284 12.3723 10.3587 12.0897 10.3587Z"
      fill={fill}
    />
    <path
      d="M4.91022 10.3587C4.62766 10.3587 4.3974 10.1284 4.3974 9.84584V7.28174H5.42304V9.84584C5.42304 10.1284 5.19278 10.3587 4.91022 10.3587Z"
      fill={fill}
    />
  </svg>
);

export default TableIcon;
